import React, { useState } from "react";
import ct from "class-types.macro";
import { NonFeaturedCategory } from "~/common/Store/models/Brand";
import useIsMounted from "~/common/useIsMounted";
import BrandPagination from "./BrandPagination";

interface Props {
  nonFeaturedCategories: NonFeaturedCategory[];
  categoriesPerPage: number;
}

const BrandNonFeaturedCategories = ({
  nonFeaturedCategories,
  categoriesPerPage,
}: Props) => {
  const mounted = useIsMounted();

  let groupOfCategories = [];
  const groupsOfCategories = [];

  for (let i = 0; i < nonFeaturedCategories.length; i += 1) {
    groupOfCategories.push(nonFeaturedCategories[i]);
    if (
      (i + 1) % categoriesPerPage === 0 ||
      i === nonFeaturedCategories.length - 1
    ) {
      groupsOfCategories.push(groupOfCategories);
      groupOfCategories = [];
    }
  }

  const [currentPage, setCurrentPage] = useState(1);
  const pagination = {
    currentPage,
    pageSize: categoriesPerPage,
    totalNumberOfItems: nonFeaturedCategories.length,
    totalPages: groupsOfCategories.length,
  };

  return (
    <>
      {mounted && (
        <div className="vendor-cats">
          <div
            className={ct(
              "bg-white",
              "border-gray-200",
              "border-solid",
              "border-r-0",
              "border-l-0",
              "border-t",
              "border-b",
              "mb-0",
              "overflow-hidden",
              "xs:rounded-sm",
              "xs:border-r-0",
              "xs:border-l"
            )}
          >
            {groupsOfCategories.map((categories, index) => (
              <div
                className="category-page"
                data-testid="category-page"
                key={String(index)}
                data-category-page-number={index + 1}
                style={
                  currentPage - 1 === index
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                {categories.map((cat, idx) => (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    href={cat?.url}
                    title={cat?.name}
                    style={{ padding: "1em 1em .75em" }}
                    data-testid="vendor-cats ag-item"
                    className={`ag-item ${ct(
                      "border-gray-200",
                      "border-solid",
                      "border-t-0",
                      "border-l-0",
                      "border-r",
                      "border-b",
                      "box-border",
                      "block",
                      "float-left",
                      "-mb-1",
                      "text-center",
                      "w-1/3",
                      "xs:w-1/4",
                      "md:w-1/5",
                      "lg:w-1/6",
                      "xl:w-12-1/2",
                      "xxxxl:w-10-1/2",
                      "outline-offset-[-4px]"
                    )}`}
                    key={`${cat?.name}${String(idx)}`}
                  >
                    <div
                      style={{ marginBottom: "0.5em" }}
                      className={ct("bg-white", "block", "relative")}
                    >
                      {/* eslint-disable-next-line jsx-a11y/alt-text */}
                      <img
                        src={cat?.image}
                        data-src={cat?.image}
                        alt=""
                        className="bLazyVisible"
                        data-testid="vendor-cats img"
                      />
                    </div>
                    <p
                      style={{ fontSize: ".75em", height: "46px" }}
                      data-testid="vendor-cats p"
                      className={`description ${ct(
                        "block",
                        "font-semibold",
                        "leading-4",
                        "mb-0",
                        "max-h-full",
                        "overflow-hidden"
                      )}`}
                    >
                      {cat?.description}
                    </p>
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
      <BrandPagination
        setCurrentPage={setCurrentPage}
        paging={pagination}
        showPagination={mounted && groupsOfCategories.length > 1}
      />
    </>
  );
};

export default BrandNonFeaturedCategories;
